export const FREE_INSURANCE = 'SEJFABETALAR';
export const FREE_INSURANCE_END_DATE = '2025-07-31';
